<template>
  <app-number
    :number="statistics.to_km"
    v-if="statistics"
  >
    <template #default="{ formatedNumber }">
      {{ formatedNumber }} {{ t('literal.km') }}
    </template>
  </app-number>
</template>

<script setup>
import { useI18n } from '@/vendors/i18n'

import AppNumber from '&/atoms/AppNumber'

defineProps({
  statistics: { type: Object, required: true }
})

const { t } = useI18n()
</script>